var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "button-group expanded-for-small",
      class: { expanded: _vm.expanded }
    },
    _vm._l(_vm.choices, function(choice) {
      return _c(
        "button",
        {
          key: choice.key,
          staticClass: "button button-radio secondary",
          class: _vm.buttonRadioClasses(choice.key),
          attrs: { value: choice.key, id: _vm.getAnalyticsId(choice.key) },
          on: {
            click: function($event) {
              _vm.emitChoice(choice.key)
            },
            focus: function($event) {
              _vm.onfocus()
            }
          }
        },
        [_vm._v("\n      " + _vm._s(choice.description) + "\n    ")]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ab8128a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab8128a8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/button-radio-selector.vue
// module id = null
// module chunks = 